import React, { useContext, useEffect } from "react"

import { cartItem as s_cartItem, itemDetails } from "./cartItem.module.css"

import { CartContext } from "src/context/CartContext"
import { Trash2 } from "react-feather"

import Button from 'src/components/core/atoms/button'
import ItemNotes from 'src/components/core/molecules/itemNotes'

const CartItem = ( { item } ) => {
  const { dispatchCart, ACTIONS, cartData, count, setCount } = useContext( CartContext )

  const cartItem = cartData.filter( cartItem => cartItem._id === item._id )[ 0 ]

  const reloader = React.useCallback( () => {
    setCount( prevState => ( { ...prevState, [ item._id ]: cartItem ? cartItem.quantity : 0 } ) )
  }, [ cartItem, item, setCount ] )

  useEffect( () => {
    reloader()
  }, [ reloader ] )

  return (
    <div className={ s_cartItem }>
      <div className={ itemDetails }>
        <header>
          <figure>
            <img src={ item.img } alt={ item.name } />
          </figure>
          <h1>{ item.name }</h1>
        </header>

        <ItemNotes item={ item } label="Add timesheet note" />
      </div>
      <span>
        <Button
          variant="quantity"
          count={ count }
          reloader={ reloader }
          item={ item } />
        <Button
          variant="text"
          size="normal"
          hover="warn"
          leftIcon={ <Trash2 /> }
          onClick={ () => {
            dispatchCart( { type: ACTIONS.CART_REMOVE_ITEM, payload: item._id } )
            reloader()
          } }
        />
      </span>
    </div>
  )
}

export default CartItem
